export const Brands = {
  AIRSITE: 'airsite',
  AIT: 'ait',
  BIAWAR: 'biawar',
  CETETHERM: 'cetetherm',
  CLIMATEMASTER: 'climatemaster',
  CONTURA: 'contura',
  CTA: 'cta',
  CTC: 'ctc',
  DZD: 'dzd',
  DANDELION: 'dandelion',
  ENERTECH: 'enertech',
  HOIAX: 'hoiax',
  IEC: 'iec',
  JAMA: 'jama',
  JASPI: 'jaspi',
  METROTHERM: 'metrotherm',
  MHI: 'mhi',
  MYUPLINK: 'myuplink',
  NIBE: 'nibe',
  NIBEF: 'nibef',
  NOVELAN: 'novelan',
  ROTH: 'roth',
  TEMPEFF: 'tempeff',
  TIKI: 'tiki',
} satisfies Record<Uppercase<string>, Lowercase<string>>;
